import { Repeat, Users } from 'lucide-react';
import { useAuthStore, type Role } from '../stores/authStore';

const ROLE_LABELS: Record<Role, string> = {
  SchoolAdmin: 'School Admin', Teacher: 'Teacher', Accountant: 'Accountant',
  Parent: 'Parent', Student: 'Student', SuperAdmin: 'Platform Admin',
  Librarian: 'Librarian', TransportManager: 'Transport', HRManager: 'HR',
  FrontDesk: 'Front Desk', ExamCoordinator: 'Exam Coordinator', DeviceAdmin: 'IT Admin',
};

export function Switcher() {
  const session = useAuthStore((s) => s.session);
  const switchRole = useAuthStore((s) => s.switchRole);
  const switchChild = useAuthStore((s) => s.switchChild);
  if (!session) return null;

  return (
    <div className="flex-col-gap2">
      {session.roles.length > 1 && (
        <div>
          <label className="switcher-field-label">
            <Repeat size={12} aria-hidden="true" />
            Role
          </label>
          <select
            aria-label="Switch role"
            value={session.activeRole}
            onChange={(e) => switchRole(e.target.value as Role)}
            className="form-input switcher-field-select"
          >
            {session.roles.map((r) => (
              <option key={r} value={r}>{ROLE_LABELS[r] ?? r}</option>
            ))}
          </select>
        </div>
      )}
      {session.children.length > 1 && (
        <div>
          <label className="switcher-field-label">
            <Users size={12} aria-hidden="true" />
            Child
          </label>
          <select
            aria-label="Switch child"
            value={session.activeChildId ?? ''}
            onChange={(e) => switchChild(e.target.value)}
            className="form-input switcher-field-select"
          >
            {session.children.map((c) => (
              <option key={c.id} value={c.id}>{c.name}</option>
            ))}
          </select>
        </div>
      )}
    </div>
  );
}
